import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import './play-icon.scss';

const PlayIcon = ({ isActive = false, type }) => (
  <div
    className={classNames('play-icon', 'play-icon--static', {
      'play-icon--stop': isActive,
      'play-icon--audio': type === 'audio',
      'play-icon--video': type === 'video',
      'play-icon--multiangle': type === 'multiangle',
    })}></div>
);

PlayIcon.propTypes = {
  isActive: PropTypes.bool,
  type: PropTypes.oneOf(['audio', 'video', 'multiangle']),
};

export default PlayIcon;
